import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { Tag } from '@octopus-do/octopus-storybook/icons'
import type { ProjectItem } from '@store/reducers/dashboard/types'
import type React from 'react'

import { StatusContent } from './components'
import { canSetProjectStatus } from './utils'

interface Props {
  project: ProjectItem
}

export const ProjectStatusMenu: React.FC<Props> = ({ project }) => {
  if (!canSetProjectStatus(project)) {
    return null
  }

  return (
    <DropdownMenu.NestedMenu
      id="status"
      title="Status"
      icon={Tag}
      content={StatusContent}
      projectId={project.id}
    />
  )
}
